export { default } from "./RoutineDetail";

